import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { X } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from '@/core/utils/cn';
const chipVariants = cva('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium', {
    variants: {
        tono: {
            neutral: 'bg-border-subtle text-text-secondary',
            primary: 'bg-primary-light text-primary',
            success: 'bg-success-fill text-success',
            warning: 'bg-warning-fill text-warning',
            danger: 'bg-danger-fill text-danger',
            info: 'bg-info-fill text-info',
        },
    },
    defaultVariants: { tono: 'neutral' },
});
export const Chip = forwardRef(({ className, tono, onRemove, children, ...props }, ref) => (_jsxs("span", { ref: ref, className: cn(chipVariants({ tono }), className), ...props, children: [children, onRemove ? (_jsx("button", { type: "button", onClick: onRemove, "aria-label": "Quitar", className: "-mr-1 rounded-full p-0.5 hover:bg-black/10 dark:hover:bg-white/10", children: _jsx(X, { className: "h-3 w-3" }) })) : null] })));
Chip.displayName = 'Chip';
